export const DATA_LOADING = 'DATA_LOADING';
export const DATA_LOADED = 'DATA_LOADED';
export const CLAIMSLISTSLOADING = 'CLAIMSLISTSLOADING';
export const CLAIMSLISTSLOADED = 'CLAIMSLISTSLOADED';
export const REPORT_LOADING = 'REPORT_LOADING';
export const REPORT_LOADED = 'REPORT_LOADED';
export const SELLERSLOADING = 'SELLERSLOADING';
export const SELLERSLOADED = 'SELLERSLOADED';